import type { FaireProductEntity } from "../../entity_types/product";

export const p_px39suuz5c: FaireProductEntity = {
  token: "p_px39suuz5c",
  type: "product",
  name: "Lightweight Scalloped Edge V-Neck Knit Cardigan",
  brandToken: "b_t9mynp4xpd",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c8facf6783e4cb191e9b2a4d3eb4ca69f848af77a24fcdd718727e92d6041cf1.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce0170b0499ded9362a293a8a1d861a0e956e4c270b6bb0923f77698a588d30c.webp",
    "https://cdn.faire.com/fastly/26a937eff8f0211bb9c6a0274b4dd636c200bf6e40692f3f4004576f6b92f8f4.webp",
    "https://cdn.faire.com/fastly/bd49e00776e174ba8ce9ae2bb9c04143ca3d983f33ff4567caea0fe203c618d2.webp",
    "https://cdn.faire.com/fastly/7ebb896222b4190289da8d983e7a6a49a8718474340a2d6909aa80004ea125f4.webp",
    "https://cdn.faire.com/fastly/a373887af758ddbe250b5395786392de7ec5ecc4dac3a4183fb8063f572404a7.webp",
    "https://cdn.faire.com/fastly/f20d288a52cafd45967492b3f3494edb843f824046a8c4bcd8b9860bb7a03c54.webp",
    "https://cdn.faire.com/fastly/efc94f36a786d982724e5f98f73769e423025c8b3c9a97bd2c30434c21d23d7c.webp",
    "https://cdn.faire.com/fastly/761f8972e8e28b009e7f1bcb3b7cd29d3a85061fd6c0a052357c472934cf7e80.webp",
    "https://cdn.faire.com/fastly/1f74a4821f9ea7c0dca097bc919b488a95adfc989739a360cf8ff7ea40fb3f86.webp",
    "https://cdn.faire.com/fastly/370d392e33d0f04e7c6da955abd3629cc5ff60aee7dcfb6e4d32da00a09d160e.webp",
    "https://cdn.faire.com/fastly/3d5d0aa377e03644115fdd000b46af5fc03d0d4c5154521cdb841cd0b5a6daa5.webp",
    "https://cdn.faire.com/fastly/145bc2260e4d2844b7ebe78901a833a2b5360340f15395aaf220f2ae3423ae63.webp",
    "https://cdn.faire.com/fastly/3f6d326e5078abed97d72e2a344edd8251bf0ca04aae6c0e714f81feed071408.webp",
    "https://cdn.faire.com/fastly/63b28ceedb42d6213132a57f3ffb699263a9fc7e38d000ccb762c219ea3b8581.webp",
    "https://cdn.faire.com/fastly/602cd51a3093a4a26a1988fd5c80f9b1d7a5b08dcedfa9267337eca77b2785f6.webp",
    "https://cdn.faire.com/fastly/416b0bb76f60fa082dece399b3cb36ec610aed8943de9de10f5a84ba5150a608.webp",
    "https://cdn.faire.com/fastly/87763ff5dcf550c2bf2d8620896349b4ee00b45235e439c788c3fc9386fabc42.webp",
    "https://cdn.faire.com/fastly/37eca7813525f020bdbf189e8c0e85bc56de6051032f6ecb0b13d164cb961643.webp",
    "https://cdn.faire.com/fastly/0c5cb3737852996098b4fdddca1a7348dcd85cb7d729e844be21372c9606197b.webp",
    "https://cdn.faire.com/fastly/afd34612366d8c4ac2906cd64fa94b1a6b3b4ae5e9adf3926f07bbd7be4262d9.png",
  ],
  priceDollars: 83.31,
  description:
    "Feminine Design – Scalloped edges and a slim V-neck silhouette create a soft, elegant look for layering.\nLightweight Comfort – Made from breathable, silky-feel knit that’s cool on the skin, ideal for spring, summer, or mild fall days.\nClassic Button Front – Features full front buttons with ribbed cuffs and hem for a secure yet flexible fit.\nEasy Styling – Pairs effortlessly with jeans, skirts, or dresses for casual days, work, or weekend outings.\nVersatile Wardrobe Essential – Perfect for transitional seasons, vacation packing, and everyday wear.\n",
  tags: [],
  msrpDollars: 166.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:16.271Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
